import React from 'react';
import PropTypes from 'prop-types';
import { z_index } from 'const/zIndex';
import styles from './modal.module.scss';

const Modal = ({
  isOpen,
  children,
  classNames,
  zIndex,
  persist,
  backgroundStyle,
  mainStyles,
}) => {
  if (!persist && !isOpen) return null;

  const display = {};
  if (persist) display.display = isOpen ? 'block' : 'none';

  return (
    <div
      id="div-1"
      className={[styles.background, ...mainStyles].join(' ')}
      style={{ zIndex: zIndex || z_index?.modalDefaultValue, ...display }}
    >
      <div
        id="div-2"
        className={[styles.background, ...mainStyles].join(' ')}
        style={backgroundStyle}
      />
      <div className={[styles.container]}>
        <div className={[...classNames, styles.content].join(' ')}>
          {children}
        </div>
      </div>
    </div>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  classNames: PropTypes.array,
  persist: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

Modal.defaultProps = {
  classNames: [],
  mainStyles: [],
  zIndex: 0,
  persist: false,
};

export default Modal;
